import { useEffect, useState } from "react";

/**
 * The one place a new Messenger message is announced inside the app.
 *
 * InboxNotifier (mounted on every logged-in screen) holds the only subscription and publishes
 * here; the inbox screen and the side-menu badge listen. One subscription per page for the whole
 * app, instead of the inbox opening its own beside it — which would also ring twice.
 */
const listeners = new Set();
let unread = 0;
const unreadListeners = new Set();

/** Every message event, inbound or outbound, as { incoming, pageId }. */
export const onInboxEvent = (fn) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
};

export const emitInboxEvent = (incoming, pageId) => {
    listeners.forEach((fn) => {
        try { fn(incoming, pageId); } catch (e) { /* one bad listener must not stop the rest */ }
    });
};

const setUnread = (n) => {
    unread = Math.max(0, n);
    unreadListeners.forEach((fn) => fn(unread));
};

/** The number of chats with an unread customer message, as the server counts it. */
export const setUnreadCount = (n) => setUnread(Number(n) || 0);

//* Ask InboxNotifier to re-count now, e.g. right after a chat was marked read.
const refreshListeners = new Set();
export const onUnreadRefresh = (fn) => {
    refreshListeners.add(fn);
    return () => refreshListeners.delete(fn);
};
export const requestUnreadRefresh = () => refreshListeners.forEach((fn) => fn());

/** Live count for badges. */
export const useInboxUnread = () => {
    const [n, setN] = useState(unread);
    useEffect(() => {
        unreadListeners.add(setN);
        setN(unread);
        return () => unreadListeners.delete(setN);
    }, []);
    return n;
};
